
//获取新闻资讯
export const getNewsList = params=>axios.get('newsMedia/list',{params});

// 获取关于子分类
export const getAboutList = ()=>axios.get('aboucompany/queryAll');

// 获取关于我的分类下富文本
export const getAbout = params=>axios.get('aboucompany/infoByType',{params});

//获取新闻与媒体子分类
export const getNewsMediaList = ()=>axios.get('newsMedia/getHeadlineType');

//获取新闻与媒体分类下新闻列表
export const getNews = params=>axios.get('newsMedia/list',{params});

//获取新闻与媒体分类下新闻详情
export const getNewsDetail = params=>axios.get('newsMedia/detail',{params});

//获取产品分类列表
export const getProduct = params=>axios.get('goodsoc/getGoodsCategoryList',{params});

//获取产品中心列表
export const getProductList = params=>axios.get('goodsoc/ocGoodslist',{params});

//获取产品中心分类下产品详情
export const getProductDetail = params=>axios.get('goodsoc/detail',{params});

//获取企业文化子分类
export const getCommunityResponsClassify = ()=>axios.get('communityRespons/getCommonwealnewsType');

//获取企业文化数据详情
export const getCultureDetail = params=>axios.get('corporateCulture/detail',{params});

// 获取企业文化列表
export const getCultureList = params=>axios.get('corporateCulture/list',{params});

//获取社会责任数据列表
export const getCommunityResponsList = params=>axios.get('communityRespons/list',{params});

//获取社会责任数据详情
export const getCommunityResponsDetail = params=>axios.get('communityRespons/detail',{params});

//获取企业文化分类
export const getCultureClassify = params=>axios.get('corporateCulture/getCorporateCultureType');

//获取研发中心、集团成员分类
export const getCenterMemberClassify = params=>axios.get('newsinfo/queryAllCategory',{params});

//获取研发中心、集团成员分类下详情/
export const getCenterMemberDetail = params=>axios.get('newsinfo/infoByThirdCategoryId',{params});

//获取招聘相关分类
export const getArticalClassify = params=>axios.get('recrui/getArticleType',{params});

// 获取招聘相关、查询岗位列表
export const getRecruiList = params=>axios.get('recrui/ocList',{params});

// 获取招聘相关、查询岗位详情
export const getRecruiDetail = params=>axios.get('recrui/detail',{params});

// 获取招聘相关、提交岗位
export const submitRecrui = params=>axios.post('recrui/application/submit',params);

// 获取关于我的分类下富文本
export const getArticalInfo = params=>axios.get('recrui/article/infoByType',{params});
